"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthlyExpenditureHistory = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var flattenDeep_1 = __importDefault(require("lodash/flattenDeep"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var Money_1 = __importDefault(require("components/Money"));
var SliderItem_1 = __importDefault(require("shared/components/Slider/SliderItem"));
var Text_1 = __importDefault(require("shared/components/Text"));
var dateTime_1 = require("utils/dateTime");
var processExpenditures_1 = require("utils/processExpenditures");
var CalendarSlider_1 = __importDefault(require("./CalendarSlider"));
var TransactionCountPill_1 = __importDefault(require("./TransactionCountPill"));
var util_1 = require("./util");
var PREFIX = 'MonthSummary';
var classes = {
    monthWrapper: "".concat(PREFIX, "-monthWrapper"),
    sliderItemWrapper: "".concat(PREFIX, "-sliderItemWrapper"),
    selected: "".concat(PREFIX, "-selected"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.monthWrapper)] = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            minWidth: 40,
            minHeight: 78,
            border: '2px solid transparent',
            padding: theme.spacing(0.5),
            '&:hover': {
                background: theme.palette.secondary.light,
                borderRadius: 12,
            },
        },
        _b[".".concat(classes.sliderItemWrapper)] = {
            color: 'black',
            minWidth: 'max-content',
            cursor: 'pointer',
            '& button': {
                minWidth: 'max-content',
            },
            height: 34,
        },
        _b[".".concat(classes.selected)] = {
            borderColor: theme.palette.secondary.main,
            borderRadius: 12,
        },
        _b);
});
var getMonthlyExpenditureHistory = function (expenditures) {
    if (!expenditures) {
        return [];
    }
    var today = new Date();
    var thisYear = today.getFullYear().toString();
    var expenditureYears = __spreadArray([], __read(new Set(Object.keys(expenditures)).add(thisYear)), false);
    var monthlyExpenditureHistory = expenditureYears
        .map(function (year) { return parseInt(year, 10); })
        .map(function (year) {
        var thisMonth = today.getMonth() + 1;
        var monthsThisYear = __spreadArray([], __read(Array(thisMonth).keys()), false).map(function (x) { return x + 1; })
            .map(function (month) {
            var _a, _b, _c;
            return ({
                label: util_1.monthLabels[month],
                yM: { year: year, month: month },
                spend: (0, processExpenditures_1.aggregateMonthlyTransactions)((_a = expenditures === null || expenditures === void 0 ? void 0 : expenditures[year]) === null || _a === void 0 ? void 0 : _a[month]) || 0,
                count: ((_c = (_b = expenditures === null || expenditures === void 0 ? void 0 : expenditures[year]) === null || _b === void 0 ? void 0 : _b[month]) === null || _c === void 0 ? void 0 : _c.length) || 0,
            });
        });
        var monthsLastYear = __spreadArray([], __read(Array(12 - thisMonth).keys()), false).map(function (x) { return x + 1 + thisMonth; })
            .map(function (month) {
            var _a, _b, _c;
            return ({
                yM: { year: year - 1, month: month },
                label: util_1.monthLabels[month],
                spend: (0, processExpenditures_1.aggregateMonthlyTransactions)((_a = expenditures === null || expenditures === void 0 ? void 0 : expenditures[year - 1]) === null || _a === void 0 ? void 0 : _a[month]) || 0,
                count: ((_c = (_b = expenditures === null || expenditures === void 0 ? void 0 : expenditures[year - 1]) === null || _b === void 0 ? void 0 : _b[month]) === null || _c === void 0 ? void 0 : _c.length) || 0,
            });
        });
        return monthsLastYear.concat(monthsThisYear);
    });
    return (0, flattenDeep_1.default)(monthlyExpenditureHistory);
};
exports.getMonthlyExpenditureHistory = getMonthlyExpenditureHistory;
var MonthSummary = function (_a) {
    var serviceStats = _a.serviceStats, onMonthClick = _a.onMonthClick, selectedMonth = _a.selectedMonth;
    var monthlyExpenditureHistory = (0, exports.getMonthlyExpenditureHistory)(serviceStats === null || serviceStats === void 0 ? void 0 : serviceStats.expenditures);
    var selectedMonthIdx = monthlyExpenditureHistory.findIndex(function (m) { return (0, isEqual_1.default)(m.yM, selectedMonth); });
    return ((0, jsx_runtime_1.jsx)(StyledBox, __assign({ display: "flex", justifyContent: "space-evenly" }, { children: (0, jsx_runtime_1.jsx)(CalendarSlider_1.default, __assign({ value: selectedMonthIdx !== -1 ? selectedMonthIdx : monthlyExpenditureHistory.length - 1 }, { children: monthlyExpenditureHistory.map(function (m) { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ className: (0, clsx_1.default)(classes.monthWrapper, (0, isEqual_1.default)(m.yM, selectedMonth) && classes.selected), onClick: function () { return onMonthClick(m.yM); } }, { children: [m.count > 0 && (0, jsx_runtime_1.jsx)(TransactionCountPill_1.default, { count: m.count, spend: m.spend }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SliderItem_1.default, __assign({ className: classes.sliderItemWrapper }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ type: "button" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, sx: { textTransform: 'uppercase' } }, { children: m.label })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: m.spend, isShortened: true }) }))] })) })) })] }), (0, dateTime_1.getYMKey)(m.yM))); }) })) })));
};
exports.default = MonthSummary;
